<template>
  <div>
    <hLargeIconHeader :text="user.userId" :icon="'person'"></hLargeIconHeader>

    <div class="row">
      <div class="col">
        <h4>Details</h4>

        <table class="table">
          <trDetail label="_id" :codeDetail="user._id" />
          <trDetail label="userId" :text="user.userId" />
          <trDetail label="timezone" :text="user.timezone" />
          <trDetail label="deviceToken" :codeDetail="user.deviceToken" />
          <trDetail label="versionNumber" :codeDetail="user.versionNumber" />
          <trDetail label="os" :codeDetail="user.os" />
          <trDetail label="createdAt" :time="user.createdAt" />
          <trDetail label="updatedAt" :time="user.updatedAt" />
          <!-- <tr
              v-for="(group, index) in groups" :key="index"
            >
          <th>Groups</th>
                <tdGroupNameLink :data="{group}"/>

          </tr> -->
        </table>
      </div>
    </div>

    <div>
      <h3 class="mt-5">
        <img class="mb-1 mr-1" src="/assets/img/people.svg" width="24" height="24" />
        Groups
      </h3>
        <table class="table table-hover">
          <thead class="thead-light">
            <tr>
              <th style="width: 25%">groupId</th>
              <th style="width: 25%">member count</th>
              <th style="width: 50%">members</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="{ active: index == currentIndex }"
              v-for="(group, index) in groups"
              :key="index"
              @click="setActive(group, index)"
              @dblclick="goToGroup(group)"
            >
              <td class="td-wrap">
                <tdGroupNameLink :data="{group}"></tdGroupNameLink>
              </td>
              <td class="td-wrap">{{group.userIds.length}}</td>
              <td class="td-wrap">{{group.userIds.join(", ")}}</td>
            </tr>
          </tbody>
        </table>
      </div>

    <div>
      <h3 class="mt-5">
        <img class="mb-1 mr-1" src="/assets/img/pencil.svg" width="24" height="24" />
        Assignments
      </h3>

      <h4 class="mt-5">
        <img class="mb-1 mr-1" src="/assets/img/person.svg" width="24" height="24" />
        User Assignments
      </h4>

      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th style="width: 20%; white-space: nowrap;">Assignment</th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('survey')">
              Survey <span style="display: inline-block; width: 1em;">{{ sortField === 'survey' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('createdAt')">
              Created At <span style="display: inline-block; width: 1em;">{{ sortField === 'createdAt' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 15%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('publishAt')">
              Publish At <span style="display: inline-block; width: 1em;">{{ sortField === 'publishAt' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 10%; white-space: nowrap;">Notif</th>
            <th style="width: 10%; white-space: nowrap;">Track</th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('answered')">
              Answered <span style="display: inline-block; width: 1em;">{{ sortField === 'answered' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(assignment, index) in sortedUserAssignments"
            :key="index"
            @dblclick="goToAssignment(assignment)"
          >
            <tdAssignmentNameLink :data="{assignment}" />
            <td>
              <a :href="'/surveys/' + assignment.survey._id">{{ assignment.survey.name }}</a>
            </td>
            <td>{{ getCalendar(assignment.createdAt) }}</td>
            <td>{{ getCalendar(assignment.publishAt) }}</td>
            <td>
              <img
                class="mr-1"
                v-if="assignment.publishNotifiedAt"
                src="/assets/img/phone-vibrate.svg"
                title="publishNotifiedAt"
              />
              <img
                class="mr-1"
                v-if="assignment.expireNotifiedAt"
                src="/assets/img/phone-vibrate.svg"
                title="expireNotifiedAt"
              />
            </td>
            <td>
              <img
                class="mr-1"
                v-if="assignment.firstOpenedAt"
                src="/assets/img/envelope-open.svg"
                title="firstOpenedAt"
              />
              <img
                class="mr-1"
                v-if="assignment.dataset"
                src="/assets/img/check.svg"
                title="dataset"
              />
            </td>
            <td>{{ assignment.dataset ? getCalendar(assignment.dataset.createdAt) : "Unanswered"}}</td>
          </tr>
        </tbody>
      </table>

      <h4 class="mt-5">
        <img class="mb-1 mr-1" src="/assets/img/people.svg" width="24" height="24" />
        Group Assignments
      </h4>

      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th style="width: 20%; white-space: nowrap;">Assignment</th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('group')">
              Group <span style="display: inline-block; width: 1em;">{{ sortField === 'group' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('survey')">
              Survey <span style="display: inline-block; width: 1em;">{{ sortField === 'survey' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('createdAt')">
              Created At <span style="display: inline-block; width: 1em;">{{ sortField === 'createdAt' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('publishAt')">
              Publish At <span style="display: inline-block; width: 1em;">{{ sortField === 'publishAt' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
            <th style="width: 10%; white-space: nowrap;">Notif</th>
            <th style="width: 10%; white-space: nowrap;">Track</th>
            <th style="width: 20%; cursor: pointer; user-select: none; color: #0056b3; white-space: nowrap;" @click="setSortField('answered')">
              Answered <span style="display: inline-block; width: 1em;">{{ sortField === 'answered' ? (sortDir === 'asc' ? '↑' : '↓') : '' }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(assignment, index) in sortedGroupAssignments"
            :key="index"
            @dblclick="goToAssignment(assignment)"
          >
            <tdAssignmentNameLink :data="{assignment}" />
            <td>
                <a :href="'/groups/' + assignment.groupId">{{ assignment.groupId }}</a>
            </td>
            <td>
              <a :href="'/surveys/' + assignment.survey._id">{{ assignment.survey.name }}</a>
            </td>
            <td>{{ getCalendar(assignment.createdAt) }}</td>
            <td>{{ getCalendar(assignment.publishAt) }}</td>
            <td>
              <img
                class="mr-1"
                v-if="assignment.publishNotifiedAt"
                src="/assets/img/phone-vibrate.svg"
                title="publishNotifiedAt"
              />
              <img
                class="mr-1"
                v-if="assignment.expireNotifiedAt"
                src="/assets/img/phone-vibrate.svg"
                title="expireNotifiedAt"
              />
            </td>
            <td>
              <img
                class="mr-1"
                v-if="assignment.firstOpenedAt"
                src="/assets/img/envelope-open.svg"
                title="firstOpenedAt"
              />
              <img
                class="mr-1"
                v-if="assignment.dataset"
                src="/assets/img/check.svg"
                title="dataset"
              />
            </td>
            <td>{{ assignment.dataset ? getCalendar(assignment.dataset.createdAt) : "Unanswered"}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import UserDataService from "../services/UserDataService";
import AssignmentDataService from "../services/AssignmentDataService";
import GroupDataService from "../services/GroupDataService";

import tdAssignmentNameLink from "./table/td/tdAssignmentNameLink";
import tdGroupNameLink from "./table/td/tdGroupNameLink";
import hLargeIconHeader from "./h/hLargeIconHeader";
import trDetail from "./table/tr/trDetail";

export default {
  name: "user",
  components: {
    tdAssignmentNameLink,
    tdGroupNameLink,
    hLargeIconHeader,
    trDetail
  },
  data() {
    return {
      user: {
        _id: "",
        userId: "",
        timeZone: "",
        deviceToken: "",
        createdAt: "",
        updatedAt: ""
      },
      assignments: [],
      groups: [],
      currentIndex: -1,
      sortField: "publishAt",
      sortDir: "asc"
    };
  },
  computed: {
    sortedUserAssignments() {
      return this.sortAssignments(this.assignments.filter(a => !a.groupId));
    },
    sortedGroupAssignments() {
      return this.sortAssignments(this.assignments.filter(a => a.groupId));
    }
  },
  methods: {
    sortAssignments(assignments) {
      const sorted = [...assignments];
      sorted.sort((a, b) => {
        let aVal, bVal;
        
        if (this.sortField === "survey") {
          aVal = a.survey?.name || "";
          bVal = b.survey?.name || "";
        } else if (this.sortField === "createdAt") {
          aVal = a.createdAt || 0;
          bVal = b.createdAt || 0;
        } else if (this.sortField === "publishAt") {
          aVal = a.publishAt || 0;
          bVal = b.publishAt || 0;
        } else if (this.sortField === "group") {
          aVal = a.groupId || "";
          bVal = b.groupId || "";
        } else if (this.sortField === "answered") {
          aVal = a.dataset ? 1 : 0;
          bVal = b.dataset ? 1 : 0;
        }
        
        if (aVal < bVal) return this.sortDir === "asc" ? -1 : 1;
        if (aVal > bVal) return this.sortDir === "asc" ? 1 : -1;
        return 0;
      });
      return sorted;
    },
    setSortField(field) {
      if (this.sortField === field) {
        this.sortDir = this.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortDir = "asc";
      }
    },
    getCalendar(dt) {
      if (!dt) return "";
      return moment(dt).calendar();
    },
    getUser(id) {
      UserDataService.get(id)
        .then(response => {
          this.user = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    getAssignmentsOfUser(id) {
      AssignmentDataService.getAssignmentsOfUser(id)
        .then(response => {
          this.assignments = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getGroupsOfUser(id) {
      GroupDataService.getGroupsOfUser(id)
        .then(response => {
          this.groups = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    goToAssignment(assignment) {
      window.location.href = "/assignments/" + assignment._id;
    }
  },
  mounted() {
    moment.locale("en-ca");
    this.message = "";
    this.getUser(this.$route.params.id);
    this.getAssignmentsOfUser(this.$route.params.id);
    this.getGroupsOfUser(this.$route.params.id);
  }
};
</script>

<style>
.edit-form {
  max-width: 300px;
  margin: auto;
}
.td-wrap {
  word-break: break-word;
}
.code-detail {
  font-family: monospace, Arial, sans-serif;
  font-size: smaller;
  color: #666;
}
</style>